import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-mobile-premiere-trailer',
  templateUrl: './mobile-premiere-trailer.component.html',
  styleUrls: ['./mobile-premiere-trailer.component.css']
})
export class MobilePremiereTrailerComponent implements OnInit {
  @Input('trailerUrl') trailerUrl:string="";
  @Input('premiereDetails') premiereDetails:any;
  videoUrl: SafeResourceUrl;
  constructor(private _sanitizer: DomSanitizer)
   {console.warn(this.trailerUrl)
    }
  video:string="";
 

  ngOnInit(): void {
    console.warn(this.trailerUrl)
  
    this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.trailerUrl); 
  }

}
